import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=df93bc4e"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df93bc4e')) {
      api.createRecord('df93bc4e', component.options)
    } else {
      api.reload('df93bc4e', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=df93bc4e", function () {
      api.rerender('df93bc4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth2/Form.vue"
export default component.exports